/*
  SIGNATURE DAILY DEAL

  Drives <daily-deal-countdown> (snippets/signature-daily-deal.liquid). Each element carries the product's scheduled
  days as YYYY-MM-DD; it shows only when today, in the store's time zone, is one of them, and counts down to the next
  midnight there. One shared interval ticks every element on the page, so cards added later (filters, infinite
  scroll, recommendations, search) start on their own and stay in sync. At midnight the element re-checks the new
  day: it hides, or keeps going when the product is scheduled again.
*/
(() => {
  const TIME_ZONE = 'Europe/Bucharest';
  const SECONDS_PER_DAY = 86400;

  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  });

  const instances = new Set();
  let interval = null;

  const pad = (value) => String(value).padStart(2, '0');

  const tick = () => {
    const parts = Object.fromEntries(formatter.formatToParts(new Date()).map((part) => [part.type, part.value]));
    const today = `${parts.year}-${parts.month}-${parts.day}`;
    const secondsLeft = SECONDS_PER_DAY - (Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second));
    const time = `${pad(Math.floor(secondsLeft / 3600))}:${pad(Math.floor((secondsLeft % 3600) / 60))}:${pad(secondsLeft % 60)}`;

    instances.forEach((element) => element.update(today, time));
  };

  class DailyDealCountdown extends HTMLElement {
    connectedCallback() {
      this.dates = (this.getAttribute('dates') || '').split(',').filter(Boolean);
      this.timeElement = this.querySelector('[data-time]');

      instances.add(this);
      tick();
      interval ??= setInterval(tick, 1000);
    }

    disconnectedCallback() {
      instances.delete(this);

      if (instances.size === 0) {
        clearInterval(interval);
        interval = null;
      }
    }

    update(today, time) {
      const active = this.dates.includes(today);

      this.hidden = !active;

      if (active && this.timeElement.textContent !== time) {
        this.timeElement.textContent = time;
      }
    }
  }

  if (!customElements.get('daily-deal-countdown')) {
    customElements.define('daily-deal-countdown', DailyDealCountdown);
  }
})();

